<div *ngIf="!barraProgreso || cargando" class="d-flex justify-content-center mt-5">
    <div class="col-9 text-center mt-5">
        <img src="../../assets/img/mascota-loader.png" style="max-width: 200px;" alt="" class="mb-3">
        <ngb-progressbar type="success" [value]="progreso"></ngb-progressbar>
    </div>
</div>

<div *ngIf="!cargando && barraProgreso" class="d-flex justify-content-center px-0 mx-0 mt-5">
    <div class="col col-lg-8">

        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-center bg-secondary text-white p-3">
            <div class="d-none d-lg-block fs-5 m-0">
                <span class="vag-bold-font text-uppercase">Inscripción </span>
                <span>Información académica</span>
            </div>
            <div class="d-block d-lg-none">
                <label class="fs-5 m-0 vag-bold-font text-uppercase">Inscripción</label>
                <label class="fs-5 m-0">Información académica</label>
            </div>
            <button (click)="logout()" type="button" class="d-inline-flex btn btn-outline text-white">
                <label class="d-none d-md-block mr-3 fs-5">Salir</label>
                <fa-icon [icon]="powerOffIcon" size="lg" class="text-white"></fa-icon>
            </button>
        </div>
        <div class="menu-cabecera d-flex justify-content-center">
            <div class="col col-lg-8">
                <img src="../../assets/img/step2.png" style="max-width: 100%;" alt="">
            </div>
        </div>

        <!-- CONTENT -->
        <div *ngIf="banderaBotonAtras && barraProgreso" class="mb-5">
            <div *ngFor="let alumnoItem of alumnos; let iAlum=index">
                <div class="d-flex justify-content-between align-items-center bg-lightblue text-white my-2 p-3">
                    <div class="d-block d-md-flex">
                        <div class="mr-1">
                            <span class="fs-5 m-0">Preferencias</span>
                            <span class="vag-bold-font text-uppercase fs-5">
                                {{alumnoItem?.firstname}}
                                {{alumnoItem?.lastname}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="d-block d-md-flex justify-content-between mt-4 border-bottom pb-3">
                    <div class="col mb-3 col-md-3">
                        <label class="label_title_textfield text-truncate fs-5">Área de interés</label>
                        <div class="input-group-prepend">
                            <select class="form-control fs-5" [(ngModel)]="alumnoItem.areaId"
                                (ngModelChange)="onSelectArea($event, iAlum)">
                                <option selected>Seleccione</option>
                                <option *ngFor="let area of areaInteresCursosActivos" [value]="area.id"
                                [selected]="areaSelected(area, iAlum, alumnoItem)">
                                    {{area.name}}</option>
                            </select>
                            
                        </div>
                    </div>
                    <div class="col mb-3 col-md-3">
                        <label class="label_title_textfield text-truncate fs-5">Código promocional *</label>
                        <input [(ngModel)]="alumnoItem.code" type="text" class="form-control fs-5"
                            (ngModelChange)="verificarCodigosIguales() ; limpiarErrorCampoCodigo(alumnoItem)"
                            placeholder="" aria-describedby="basic-addon1" [required]="!tutor.isCampus">
                        <div *ngIf="alumnoItem.codigoTieneError && !tutor.isCampus" class="alert alert-danger">
                            <div>
                                {{alumnoItem.mensajeErrorCodigo}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-block d-md-flex justify-content-between mt-4">
                    <div class="col mb-3">
                        <label class="label_title_textfield text-truncate fs-5">Municipio *</label>
                        <div class="input-group-prepend">
                            <select class="form-control fs-5" [(ngModel)]="alumnoItem.municipioId"
                                (ngModelChange)="onSelectMunicipality($event, iAlum)"
                                [disabled]="(habiliarMunicipio[iAlum] == null) || habiliarMunicipio[iAlum]">
                                <option hidden selected>Seleccione</option>
                                <option *ngFor="let municipalityItem of filterMunicipalityByCourseEndDate(cursos, municipalityCenters); let i=index"
                                    [value]="municipalityItem.id">{{municipalityItem.municipality}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col mb-3">
                        <label class="label_title_textfield text-truncate fs-5">Centro *</label>
                        <div class="input-group-prepend">
                            <select class="form-control fs-5" [(ngModel)]="alumnoItem.centroId"
                                (ngModelChange)="onSelectCenter($event, iAlum)"
                                [disabled]="(habiliarCentro[iAlum] == null) || habiliarCentro[iAlum]">
                                <option hidden selected>Seleccione</option>
                                <!-- <option *ngFor="let center of centrosPorMunicipio; let i=index" [value]="center.id">
                                    {{center.description}}</option> -->
                                <option *ngFor="let center of getCentrosDelAlumno(alumnoItem.id, cursos); let i=index"
                                    [value]="center.id">
                                    {{center.description}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col mb-3">
                        <label class="label_title_textfield text-truncate fs-5">Día de la semana *</label>
                        <div class="input-group-prepend">
                            <select class="form-control fs-5" [(ngModel)]="alumnoItem.dia"
                                (ngModelChange)="onSelectDay($event, iAlum)"
                                [disabled]="(habiliarDiaSemana[iAlum] == null) || habiliarDiaSemana[iAlum]">
                                <option hidden selected>Seleccione</option>
                                <option *ngFor="let day of daysOfWeek" [value]="day.value">{{day.label}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col mb-3">
                        <label class="label_title_textfield text-truncate fs-5">Horario *</label>
                        <div class="input-group-prepend">
                            <select class="form-control fs-5" [(ngModel)]="alumnoItem.horaCursoSeleccionada"
                                [disabled]="(habiliarHora[iAlum] == null) || habiliarHora[iAlum]"
                                (ngModelChange)="onSelectHourly($event, iAlum)">
                                <option hidden selected>Seleccione</option>
                                <option *ngFor="let day of alumnoItem.horasCursos" [value]="day">
                                    {{day}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="py-2 d-flex justify-content-between">
                <!-- <button [disabled]="habiliarBotonSiguiente || this.codigosIguales" (click)="this.banderaBotonSiguiente = true; this.banderaBotonAtras = false;"
            type="button" class="btn btn-primary btn-lg button">Siguiente</button> -->
                <button [routerLink]="['../registro']" type="button" class="btn btn-outline-secondary btn-lg"
                    (click)="actualizarIdTutor()">Atrás</button>
                <button [disabled]="habiliarBotonSiguiente || this.codigosIguales"
                    [ngClass]="{'opacity-1': habiliarBotonSiguiente || this.codigosIguales}"
                    (click)="verificarCodesPromo();" type="button" class="btn btn-secondary btn-lg">Siguiente</button>
            </div>
        </div>

        <div *ngIf="!banderaMensajeWeb && !cargando && barraProgreso && banderaBotonSiguiente" class="mb-5">
            <div *ngFor="let alumnoItem of this.alumnos;let i=index">
                <div class="d-flex justify-content-between align-items-center bg-lightblue text-white my-2 p-3">
                    <div class="d-block d-md-flex">
                        <div class="mr-1">
                            <span class="fs-5 m-0">Preferencias</span>
                        </div>
                        <div class="vag-bold-font text-uppercase fs-5">
                            <span>
                                {{alumnoItem?.firstname}}
                                {{alumnoItem?.lastname}}
                            </span>
                        </div>
                    </div>
                    <label style="display: flex; float: right"
                        *ngIf="alumnoItem.time != null">{{alumnoItem?.time.minutes}}:{{alumnoItem?.time.seconds}}</label>
                </div>
                <label *ngIf="cursosFiltradosAlumnoAMostrar[i] === null"
                    class="label_title_textfield text-truncate my-2">Especifique
                    un filtro por favor</label>
                <div [ngClass]="{'pb-4 border-bottom border-secondary mb-4': banderaListaDeEspera[i]}" class="my-2">
                    <div *ngIf="banderaListaDeEspera[i]" class="d-flex">
                        <div class="d-none d-lg-flex col-lg-4">
                            <img src="../../assets/img/mascota.png" style="max-width: 80%;" alt="">
                        </div>
                        <div class="col-12 col-lg-8">
                            <label class="fs-5 mt-5">
                                <p>¡Gracias <span class="vag-bold-font">{{tutor?.firstname}}</span> ya estás
                                    apuntado en lista
                                    de espera!</p>
                                <p>
                                    Te contactaremos si hubiera alguna plaza disponible para <span
                                        class="vag-bold-font">{{alumnoItem?.firstname}}</span>
                                    en {{alumnoItem?.centro}} el día y horario seleccionados.</p>
                            </label>
                        </div>

                    </div>


                    <div
                        *ngIf="!banderaListaDeEspera[i] && (cursosFiltradosAlumnoAMostrar[i].length == 0 || !excluirEncabezadoArrayVacio(i, alumnoItem))">
                        <p class="label_title_textfield text-truncate">No existen plazas disponibles en <span
                                class="vag-bold-font">{{alumnoItem?.centro}}</span>
                            para
                            <span class="vag-bold-font">{{alumnoItem?.firstname}}
                                {{alumnoItem?.lastname}}</span> el día y horario elegidos. Dinos por favor qué
                            prefieres
                        </p>
                        <div *ngIf="banderaBusquedaOtrasOpciones[i]">
                            <p>No tenemos otras opciones disponibles en este momento
                                anotate en la lista de espera y te contactaremos lo mas pronto posible</p>
                            <div class="form-check">
                                <input (click)="alumnoItem.cursoElegido ='ninguno'" class="form-check-input"
                                    type="radio" ng-model="checked1" name="flexRadioDefault{{i}}"
                                    disabled="{{banderaHabilitarRadioButtonOtrasOpciones[i]}}" id="flexRadioDefault2"
                                    (change)="checkOtrasOpciones = false">
                                <label class="form-check-label" for="flexRadioDefault2">
                                    No me interesa apuntarme en la lista de espera por el momento
                                </label>
                            </div>
                        </div>
                        <div *ngIf="!banderaBusquedaOtrasOpciones[i]" class="form-check">
                            <input (click)="alumnoItem.cursoElegido ='otras' ; checkOtrasOpciones = true"
                                class="form-check-input" type="radio" name="flexRadioDefault{{i}}"
                                id="flexRadioDefault1" disabled="{{banderaHabilitarRadioButtonOtrasOpciones[i]}}">
                            <label class="form-check-label" for="flexRadioDefault1">
                                Sugiéreme otras opciones
                            </label>
                        </div>
                        <div class="form-check">
                            <input (click)="alumnoItem.cursoElegido ='lista'" class="form-check-input" type="radio"
                                ng-model="checked1" name="flexRadioDefault{{i}}"
                                disabled="{{banderaHabilitarRadioButtonOtrasOpciones[i]}}" id="flexRadioDefault2"
                                (change)="checkOtrasOpciones = false ;">
                            <label class="form-check-label" for="flexRadioDefault2">
                                Sólo puede asistir ese día y horario,
                                deseo apuntarlo en lista de espera
                            </label>
                        </div>

                        <div *ngIf="!banderaBotonConfirmarOtrasOpciones[i]" class="d-flex justify-content-end">
                            <button [disabled]="alumnoItem.cursoElegido == null"
                                (click)="escogerOtrasOpcionesOListaEspera(i, alumnoItem) " type="button"
                                class="btn btn-primary btn-lg">Aceptar</button>
                        </div>
                    </div>
                    <div *ngIf="excluirEncabezadoArrayVacio(i, alumnoItem)">
                        <div *ngIf="cursosFiltradosAlumnoAMostrar[i].length !== 0">
                            <table class="d-none d-md-table text-center table table-responsive">
                                <thead>
                                    <tr>
                                        <td class="border-0"></td>
                                        <td class="border-0">
                                            <label class="label_title_textfield text-truncate">Municipio</label>
                                        </td>
                                        <td class="border-0">
                                            <label class="label_title_textfield text-truncate">Centro</label>
                                        </td>
                                        <td class="border-0">
                                            <label class="label_title_textfield text-truncate">Curso</label>
                                        </td>
                                        <td class="border-0">
                                            <label class="label_title_textfield text-truncate">Día</label>
                                        </td>
                                        <td class="border-0">
                                            <label class="label_title_textfield text-truncate">Hora</label>
                                        </td>
                                        <td class="border-0">
                                            <label class="label_title_textfield text-truncate">Plazas</label>
                                        </td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let curso of cursosFiltradosAlumnoAMostrar[i];let iCurso=index">
                                        <ng-container *ngIf="excluirCurso(curso, alumnoItem, i)">
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <input (click)="elegirCurso(alumnoItem, curso, i)"
                                                    class="radio_check select-course" name="option{{i}}"
                                                    disabled="{{banderaHabilitarRadioButton[i]}}"
                                                    [checked]="alumnoItem?.cursoElegido?.id == curso.id" type="radio" />
                                            </td>
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <label class="">{{curso.descripcionMunicipio}}</label>
                                            </td>
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <label class="">{{curso?.descripcionCentro}}</label>
                                            </td>
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <label class="">{{curso?.description}}</label>
                                            </td>
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <label *ngFor="let cursoDia of curso.weekDays" class="">
                                                    {{cursoDia}}
                                                </label>
                                            </td>
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <label class="">
                                                    {{curso.startTime.hour + ":" + curso.startTime.minute
                                                    + " - " + curso.endTime.hour + ":" +
                                                    curso.endTime.minute}}</label>
                                            </td>
                                            <td class="border-2 border-top border-bottom border-secondary">
                                                <label class="">{{curso?.maximun - curso?.high}}</label>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </tbody>
                            </table>

                            <ul class="d-flex d-md-none list-group mb-3">
                                <li *ngFor="let curso of cursosFiltradosAlumnoAMostrar[i];let iCurso=index"
                                    class="list-group-item border-secondary"
                                    (click)="elegirCurso(alumnoItem, curso, i)">

                                    <div class="d-flex justify-content-between">
                                        <div class="col-10 p-0 m-0">
                                            <h5>{{curso.description}}</h5>
                                        </div>
                                        <div class="d-flex flex-column col-2 align-items-end p-0 m-0">
                                            <input (click)="elegirCurso(alumnoItem, curso, i)" class="radio_check"
                                                name="option{{i}}" disabled="{{banderaHabilitarRadioButton[i]}}"
                                                [checked]="alumnoItem.cursoElegido === curso" type="radio" />
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-between">
                                        <div class="col p-0 m-0">
                                            <span>{{curso.descripcionMunicipio}} - {{curso?.descripcionCentro}}</span>
                                        </div>
                                        <div class="col p-0 m-0 d-block">
                                            <span>Plazas libres: <label class="">{{curso?.maximun -
                                                    curso?.high}}</label></span>
                                        </div>
                                    </div>

                                    <div class="d-flex">
                                        <div class="col p-0 m-0">
                                            <fa-icon [icon]="calendarIcon" size="md" class="mx-1 text-dark">
                                            </fa-icon>
                                            <span *ngFor="let cursoDia of curso.weekDays" class="">
                                                {{cursoDia}}
                                            </span>
                                        </div>
                                        <div class="col p-0 m-0">
                                            <label class="">
                                                {{curso.startTime.hour + ":" + curso.startTime.minute
                                                + "h - " + curso.endTime.hour + ":" +
                                                curso.endTime.minute + "h"}}</label>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <div class="d-flex justify-content-end" *ngIf="excluirEncabezadoArrayVacio(i, alumnoItem)">
                                <button *ngIf="!banderaBotonConfirmar[i]"
                                    [disabled]="alumnoItem.cursoElegido == null || alumnoItem.cursoElegido == 'otras'"
                                    (click)="banderaBotonConfirmar[i] = true ; confirmarCursoElegido(alumnoItem, i);
                        banderaHabilitarRadioButton[i]= false" type="button" class="btn btn-primary btn-lg"
                                    [ngClass]="{'opacity-1': alumnoItem.cursoElegido == null || alumnoItem.cursoElegido == 'otras'}">Selecciona
                                    y confirma</button>
                                <button *ngIf="banderaBotonConfirmar[i]" (click)="desmarcarCurso(alumnoItem, i) ; banderaBotonConfirmar[i] = false ; 
                                banderaHabilitarRadioButton[i] = null" type="button"
                                    class="btn btn-outline-secondary btn-lg">Desmarcar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between py-5">
                <button *ngIf="!banderaMensajeWeb"
                    (click)="banderaBotonSiguiente = false ; banderaBotonAtras = true  ; limpiarFiltros()" type="button"
                    class="btn btn-outline-secondary btn-lg">Atrás</button>
                <button *ngIf="!banderaMensajeWeb" [disabled]="banderaBotonSiguienteGuardar"
                    [ngClass]="{'opacity-1': banderaBotonSiguienteGuardar}" type="button"
                    class="btn btn-secondary btn-lg" (click)="siguiente()">Siguiente</button>
            </div>
        </div>
        <div *ngIf="banderaMensajeWeb && !cargando">
            <div class="title_center mb-3">
                <label class="fs-5">Mensaje <span class="vag-bold-font text-uppercase">WEB</span></label>
            </div>
            <div class="d-flex justify-content-center">
                <div class="d-none d-lg-flex col-lg-4">
                    <img src="../../assets/img/mascota.png" style="max-width: 80%;" alt="">
                </div>
                <div class="col-12 col-lg-8">
                <label class="fs-5 mt-5">
                    <p>¡Gracias por tu inscripción <span class="vag-bold-font"> {{tutor.firstname}}  </span><br>
                        Te esperamos en Playbots para tu día de prueba. </p><br>
                    <p>Si te has apuntado a una lista de espera, te contactaremos</p>
                    <p>si hubiera alguna plaza disponible para el  centro, día y horario seleccionados.</p>
                </label>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end py-5">
            <button *ngIf="banderaMensajeWeb" class="btn btn-outline-secondary btn-lg"
                (click)="logout()">Finalizar</button>
        </div>
    </div>
</div>